import PageError from "./PageError.jsx";
import { Component } from "react";
import { Loader } from "../components/Loader/Loader";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false
        };
    }

    processChunkLoadError() {
        window.location.reload();
    }

    componentDidCatch(error) {
        console.error(error);
        this.setState({error: error});
        if (error.name === 'ChunkLoadError') {
            this.processChunkLoadError(error);
        }
    }

    render() {
        if (typeof this.state.error !== "boolean" && this.state.error.name === 'ChunkLoadError') {
            return <Loader show/>
        } else if (this.state.error) {
            return <PageError headerText={'Something went wrong'} code={'500'} error={this.state.error}/>
        } else {
            return <>{this.props.children}</>;
        }
    }
}

export default ErrorBoundary;